// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable new-cap, babel/new-cap, func-names, default-param-last */
import { List, Record } from "immutable"

import type { additionalServicesRequestForm } from "../../../../../../services/bookings/bookingsApi"
import { additionalServicesRequest } from "../../../../../../services/bookings/bookingsApi"
import type { Service } from "../../../../../../consts/additionalServices"
import { SERVICES } from "../../../../../../consts/additionalServices"
import type {
  Action,
  AdditionalServicesStateInst,
  AdditionalServicesStateType,
  ResetAction,
  SetCategoryAction,
} from "./types"
import {
  RESET,
  SET_CATEGORY,
  SUBMIT,
  SUBMIT_FAILURE,
  SUBMIT_REQUEST,
  SUBMIT_SUCCESS,
} from "./consts"

const InitialState: AdditionalServicesStateType = Record({
  category: SERVICES.SEATING,
  success: false,
  loading: false,
  error: null,
  // @ts-expect-error: Flow to TS migration.
  submitted: new List(),
})

export default function (
  state: AdditionalServicesStateInst | null | undefined = new InitialState(),
  action: Action,
) {
  if (!(state instanceof InitialState)) return new InitialState(state)

  switch (action.type) {
    case SET_CATEGORY:
      return state.set("category", action.category)

    case RESET:
      return new InitialState({
        submitted: state.submitted, // we want to preserve history
      })

    case SUBMIT_REQUEST:
      return state.set("success", false).set("loading", true).set("error", null)

    case SUBMIT_SUCCESS:
      return (
        state
          // FIXME: a method has been detected that possibly mutates the object, consider a more
          // functional approach (Ramda might help)

          // @ts-expect-error: Flow to TS migration.
          .update("submitted", (submitted) => submitted.push(action.request))
          .set("success", true)
          .set("loading", false)
          .set("error", null)
      )

    case SUBMIT_FAILURE:
      return state.set("success", false).set("loading", false).set("error", String(action.error))

    default:
      return state
  }
}

export const setCategory = (category: Service): SetCategoryAction => ({
  type: SET_CATEGORY,
  category,
})

export const reset = (): ResetAction => ({
  type: RESET,
})

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const submit = (booking: any, payload: additionalServicesRequestForm) => ({
  type: SUBMIT,
  action: payload.category, // action added for dataDogMapper
  request: payload,
  promise: additionalServicesRequest(booking, payload),
  _track: { bid: booking.id, request: payload },
})
